import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Dispatch, connect } from 'react-redux';
import { IReportState, IApplicationState, AppActionCreators, ReportActionCreators, IPatientExportabilityReportResponse } from '@nkr/store/index';
import { ICenterBase, IPatientExportability, IExportabilityGroup, IUser } from '@nkr/models/index';
import { ColumnApi, CsvExportParams, GridApi, GridReadyEvent, ProcessCellForExportParams } from 'ag-grid-community';
import { Button, ButtonToolbar, FormControl, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import { HeaderWrapper } from './styles';
import Tabs from '@nkr/views/swap-management/tabs-new';
import PatientExportabilityReportGrid from './patient-exportability-grid';

interface IOwnProps { }

interface IStateProps {
    user: IUser,
    reports: IReportState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getPatientExportabilityReport: (centerId: number) => Promise<IPatientExportabilityReportResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    centerId: number,
    report: IPatientExportability[],    
    radioFilter: number,
    centerList: ICenterBase[],
    gridApi: GridApi,
    columnApi: ColumnApi
}

class PatientExportabilityReport extends React.Component<TProps, IState> {
    readonly state: IState = {
        centerId: 0,
        report: [],
        radioFilter: 0,
        centerList: [],
        gridApi: null,
        columnApi: null
    }

    componentDidMount = () => {
        this.getData();
    }

    onGridReady = (e: GridReadyEvent) => {
        this.setState({
            gridApi: e.api,
            columnApi: e.columnApi
        });
    }

    getData = () => {
        this.props.showLoading('Getting report data, one moment please...').then(() => {
            this.props.getPatientExportabilityReport(this.state.centerId)
                .then(response => {
                    if (response.data.success) {

                        let { report, centerList } = response.data.results;

                        this.setState({
                            report,
                            centerList
                        });

                        //let { report } = response.data.results;
                        //let report = response.data.results;

                        //this.setState({
                        //    report                         
                        //});
                    }
                }).catch((ex) => {
                    alert('An error occured while loading report data');
                }).finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleCenterChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            centerId: parseInt(e.currentTarget.value)
        }, () => {
            this.getData();
        });
    }

    csvExport = () => {
        let params: CsvExportParams = {
            columnGroups: true,
            fileName: 'exportability-report.csv',
            processCellCallback: (params: ProcessCellForExportParams) => {
                let colDef = params.column.getColDef();

                if (colDef.headerName == 'Rank')
                    return params.node.rowIndex + 1;
                else if (colDef.colId == 'xpDate')
                    return moment(params.value).format('MM/DD/YYYY');

                return params.value;
            }
        };

        this.state.gridApi.exportDataAsCsv(params);
    }

    render = () => {
        return (
            <>
                <Tabs tabKey='PATIENT-EXPORTABILITY' subTabKey='' counts={null} user={this.props.user} />

                <HeaderWrapper>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 15 }}>
                        <div style={{ fontSize: 28, fontWeight: 500 }}>
                            Patient Exportability Monitoring Report
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}>
                                <div style={{ marginRight: 5 }}>Center:</div>
                                <div>
                                    <FormControl
                                        componentClass='select'
                                        value={this.state.centerId}
                                        onChange={this.handleCenterChange}
                                    >
                                        <option value={0}>- All Centers -</option>
                                        {this.state.centerList.map(item =>
                                            <option value={item.id}>{item.alias}</option>
                                        )}
                                    </FormControl>
                                </div>
                            </div>                                                        
                        </div>
                        <div>
                            <Button onClick={this.csvExport}>Export CSV</Button>
                        </div>
                    </div>
                </HeaderWrapper>

                <PatientExportabilityReportGrid
                    report={this.state.report}
                    onGridReady={this.onGridReady}
                />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        user: appState.app.user,
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getPatientExportabilityReport: (centerId) => {
            return dispatch(ReportActionCreators.getPatientExportabilityReport(centerId));
        }
    }
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(PatientExportabilityReport);